import {
  CasEntityRHFSelect,
  CasEntitySelect,
  componentProps,
  CasEntitySelectProps,
} from 'src/compass/shared/components';

const entity = "Employee/RiskManager";

export function CasRHFRiskManagerSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect(entity, props);
}

export function CasRiskManagerSelect(props: componentProps) {
  return CasEntitySelect(entity, props);
}
